import axios from 'axios';
import { MetapromptingSession, Statistics } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const api = {
  createSession: async (prompt: string): Promise<MetapromptingSession> => {
    const response = await axios.post(`${API_BASE_URL}/metaprompting/sessions`, {
      prompt
    });
    return response.data.session;
  },

  runIteration: async (sessionId: string): Promise<MetapromptingSession> => {
    const response = await axios.post(
      `${API_BASE_URL}/metaprompting/sessions/${sessionId}/iterate`
    );
    return response.data.session;
  },

  getSession: async (sessionId: string): Promise<MetapromptingSession> => {
    const response = await axios.get(
      `${API_BASE_URL}/metaprompting/sessions/${sessionId}`
    );
    return response.data.session;
  },

  cancelSession: async (sessionId: string): Promise<void> => {
    await axios.delete(
      `${API_BASE_URL}/metaprompting/sessions/${sessionId}/cancel`
    );
  },

  getStatistics: async (): Promise<Statistics> => {
    const response = await axios.get(`${API_BASE_URL}/statistics`);
    return response.data.data;
  },

  resetStatistics: async (): Promise<Statistics> => {
    const response = await axios.post(`${API_BASE_URL}/statistics/reset`);
    return response.data.data;
  }
};